/**
 * ADVENTSKALENDER LANDING PAGE - INTERAKTIVE FUNKTIONEN
 * Festlich & Verspielt Design
 */

/**
 * DEBUG HELPER FUNKTIONEN
 */
function debugLog(...args) {
  if (window.location.search.includes('debug=true')) {
    console.log('[Advent]', ...args);
  }
}

function debugError(...args) {
  console.error('[Advent ERROR]', ...args);
}

function debugWarn(...args) {
  console.warn('[Advent WARN]', ...args);
}

class AdventCalendar {
  constructor() {
    this.config = window.AdventCalendarConfig || {};
    
    // TEST-MODUS: Überprüfe URL-Parameter
    this.testMode = this.getTestModeFromURL();
    
    if (this.testMode.enabled) {
      // Simuliere Dezember mit dem angegebenen Tag
      this.today = new Date(2024, 11, this.testMode.day); // Monat 11 = Dezember
      this.currentDay = this.testMode.day;
      this.currentMonth = 11; // Dezember
      this.currentYear = 2024;
      debugLog(`🎄 TEST-MODUS: Simuliere ${this.currentDay}. Dezember 2024`);
    } else {
      // Normaler Modus
      this.today = new Date();
      this.currentDay = this.today.getDate();
      this.currentMonth = this.today.getMonth();
      this.currentYear = this.today.getFullYear();
    }
    
    this.openedDoors = this.loadOpenedDoors();
    
    this.init();
  }
  
  /**
   * TEST-MODUS: Lese URL-Parameter
   * Verwendung: ?testday=5 (simuliert 5. Dezember)
   * Verwendung: ?testday=24 (simuliert 24. Dezember - alle Türchen offen)
   */
  getTestModeFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    const testDay = urlParams.get('testday');
    
    if (testDay) {
      const day = parseInt(testDay);
      if (day >= 1 && day <= 24) {
        return { enabled: true, day: day };
      }
    }
    
    return { enabled: false, day: null };
  }

  init() {
    // Test-Modus Banner anzeigen
    if (this.testMode.enabled) {
      this.showTestModeBanner();
    }
    
    this.initSnowfall();
    // Countdown und Progress Bar entfernt
    this.initCalendarDoors();
    this.initModal();
    
    // Optional: Christmas Music
    if (this.config.audioEnabled) {
      this.initBackgroundAudio();
    }
  }
  
  /**
   * TEST-MODUS: Banner anzeigen
   */
  showTestModeBanner() {
    const banner = document.createElement('div');
    banner.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      background: linear-gradient(135deg, #ff6b00, #ff8c00);
      color: white;
      padding: 15px 20px;
      text-align: center;
      font-weight: 700;
      font-size: 1rem;
      z-index: 10000;
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
      border-bottom: 3px solid #fff;
    `;
    banner.innerHTML = `
      🧪 <strong>TEST-MODUS AKTIV</strong> - Simuliert: ${this.currentDay}. Dezember 2024
      <button onclick="this.parentElement.remove()" style="
        margin-left: 20px;
        background: white;
        color: #ff6b00;
        border: none;
        padding: 5px 15px;
        border-radius: 20px;
        font-weight: 700;
        cursor: pointer;
      ">Schließen</button>
    `;
    
    document.body.prepend(banner);
  }

  /**
   * SCHNEEFLOCKEN ANIMATION
   */
  initSnowfall() {
    const snowfallContainer = document.querySelector('.snowfall-container');
    if (!snowfallContainer) return;

    const snowflakeCount = this.isMobile() ? 30 : 50;
    const snowflakeChars = ['❄', '❅', '❆', '✻', '✼', '❉'];

    for (let i = 0; i < snowflakeCount; i++) {
      const snowflake = document.createElement('div');
      snowflake.className = 'snowflake';
      snowflake.textContent = snowflakeChars[Math.floor(Math.random() * snowflakeChars.length)];
      
      // Zufällige Position und Geschwindigkeit
      const leftPosition = Math.random() * 100;
      const animationDuration = 5 + Math.random() * 10;
      const animationDelay = Math.random() * 5;
      const fontSize = 0.5 + Math.random() * 1.5;
      
      snowflake.style.left = `${leftPosition}%`;
      snowflake.style.fontSize = `${fontSize}em`;
      snowflake.style.animationDuration = `${animationDuration}s`;
      snowflake.style.animationDelay = `${animationDelay}s`;
      
      snowfallContainer.appendChild(snowflake);
    }
  }

  /**
   * COUNTDOWN BIS WEIHNACHTEN
   */
  initCountdown() {
    const countdownElement = document.getElementById('christmas-countdown');
    if (!countdownElement) return;

    const updateCountdown = () => {
      const now = new Date();
      const currentYear = now.getFullYear();
      let christmas = new Date(currentYear, 11, 24, 23, 59, 59); // 24. Dezember

      // Wenn Weihnachten vorbei ist, nächstes Jahr
      if (now > christmas) {
        christmas = new Date(currentYear + 1, 11, 24, 23, 59, 59);
      }

      const timeDiff = christmas - now;

      if (timeDiff <= 0) {
        const christmasText = this.config.translations?.countdown?.christmas || '🎄 Frohe Weihnachten! 🎄';
        countdownElement.innerHTML = `<div class="countdown-complete">${christmasText}</div>`;
        return;
      }

      const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

      // Übersetzungen aus Config holen
      const t = this.config.translations?.countdown || {};
      const daysLabel = t.days || 'Tage';
      const hoursLabel = t.hours || 'Stunden';
      const minutesLabel = t.minutes || 'Minuten';
      const secondsLabel = t.seconds || 'Sekunden';

      countdownElement.innerHTML = `
        <div class="countdown-unit">
          <span class="countdown-number">${days}</span>
          <span class="countdown-label">${daysLabel}</span>
        </div>
        <div class="countdown-unit">
          <span class="countdown-number">${hours}</span>
          <span class="countdown-label">${hoursLabel}</span>
        </div>
        <div class="countdown-unit">
          <span class="countdown-number">${minutes}</span>
          <span class="countdown-label">${minutesLabel}</span>
        </div>
        <div class="countdown-unit">
          <span class="countdown-number">${seconds}</span>
          <span class="countdown-label">${secondsLabel}</span>
        </div>
      `;
    };

    updateCountdown();
    setInterval(updateCountdown, 1000);
  }

  /**
   * KALENDER-TÜRCHEN LOGIK
   */
  initCalendarDoors() {
    const doors = document.querySelectorAll('.calendar-door');
    
    debugLog(`🎄 Initialisiere ${doors.length} Türchen...`);
    
    doors.forEach(door => {
      const doorNumber = parseInt(door.dataset.day);
      
      // Status setzen
      this.updateDoorState(door, doorNumber);
      
      // Click Event
      door.addEventListener('click', () => this.handleDoorClick(door, doorNumber));
      
      // Keyboard Support
      door.addEventListener('keypress', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.handleDoorClick(door, doorNumber);
        }
      });
    });
    
    debugLog(`✅ Alle Türchen initialisiert. Test-Modus: ${this.testMode.enabled ? `Tag ${this.currentDay}` : 'Aus'}`);
  }

  updateDoorState(door, doorNumber) {
    const isDecember = this.currentMonth === 11; // Dezember = Monat 11
    const canOpen = isDecember && doorNumber <= this.currentDay;
    const isOpened = this.openedDoors.includes(doorNumber);
    const isToday = doorNumber === this.currentDay && isDecember;

    door.classList.remove('locked', 'opened', 'today');

    if (isOpened) {
      door.classList.add('opened');
      door.setAttribute('aria-label', `Türchen ${doorNumber} - Bereits geöffnet`);
    } else if (canOpen) {
      if (isToday) {
        door.classList.add('today');
        door.setAttribute('aria-label', `Türchen ${doorNumber} - Heute! Klicke zum Öffnen`);
      } else {
        door.setAttribute('aria-label', `Türchen ${doorNumber} - Klicke zum Öffnen`);
      }
    } else {
      door.classList.add('locked');
      door.setAttribute('aria-label', `Türchen ${doorNumber} - Noch verschlossen`);
      
      // Lock Icon hinzufügen
      if (!door.querySelector('.lock-icon')) {
        const lockIcon = document.createElement('div');
        lockIcon.className = 'lock-icon';
        lockIcon.innerHTML = '🔒';
        door.querySelector('.door-front').appendChild(lockIcon);
      }
    }
  }

  handleDoorClick(door, doorNumber) {
    const isDecember = this.currentMonth === 11;
    const canOpen = isDecember && doorNumber <= this.currentDay;
    const isOpened = this.openedDoors.includes(doorNumber);

    // Debug-Log für Fehlersuche
    debugLog(`🚪 Türchen ${doorNumber} geklickt:`, {
      doorNumber,
      currentDay: this.currentDay,
      currentMonth: this.currentMonth,
      isDecember,
      canOpen,
      isOpened,
      testMode: this.testMode.enabled
    });

    // Locked Door - Shake Animation
    if (!canOpen) {
      this.shakeDoor(door);
      this.showLockedMessage(doorNumber);
      return;
    }

    // Already opened - Show Modal again
    if (isOpened) {
      this.showDoorModal(door, doorNumber);
      return;
    }

    // Open Door
    this.openDoor(door, doorNumber);
  }

  openDoor(door, doorNumber) {
    // Sound Effect
    this.playSound('door-open');
    
    // Animation
    door.classList.add('opened');
    
    // In Local Storage speichern
    this.openedDoors.push(doorNumber);
    this.saveOpenedDoors();
    
    // Modal nach Animation zeigen
    setTimeout(() => {
      this.showDoorModal(door, doorNumber);
    }, 800);
  }

  shakeDoor(door) {
    door.style.animation = 'shake 0.5s';
    this.playSound('locked');
    
    setTimeout(() => {
      door.style.animation = '';
    }, 500);
  }

  showLockedMessage(doorNumber) {
    const isDecember = this.currentMonth === 11;
    let message;

    if (!isDecember) {
      message = `Ho-Ho-Ho! 🎅<br>Der Adventskalender startet am 1. Dezember!`;
    } else {
      const daysUntil = doorNumber - this.currentDay;
      message = `Geduld, geduld! 🎁<br>Türchen ${doorNumber} öffnet sich in ${daysUntil} ${daysUntil === 1 ? 'Tag' : 'Tagen'}!`;
    }

    this.showTemporaryMessage(message);
  }

  showTemporaryMessage(message) {
    const existingMessage = document.querySelector('.temp-message');
    if (existingMessage) existingMessage.remove();

    const messageDiv = document.createElement('div');
    messageDiv.className = 'temp-message';
    messageDiv.innerHTML = message;
    messageDiv.style.cssText = `
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: linear-gradient(135deg, #C41E3A, #8B1E3F);
      color: white;
      padding: 30px 50px;
      border-radius: 15px;
      border: 4px solid #D4AF37;
      font-size: 1.5rem;
      font-weight: 700;
      text-align: center;
      z-index: 10000;
      box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
      animation: fadeInOut 3s ease;
    `;

    document.body.appendChild(messageDiv);

    setTimeout(() => {
      messageDiv.remove();
    }, 3000);
  }

  /**
   * MODAL FÜR TÜRCHEN-INHALT
   */
  initModal() {
    const modal = document.getElementById('advent-modal');
    if (!modal) return;

    const closeBtn = modal.querySelector('.modal-close');
    
    // Close Button
    closeBtn?.addEventListener('click', () => this.closeModal());
    
    // Click outside to close
    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        this.closeModal();
      }
    });
    
    // ESC Key to close
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('active')) {
        this.closeModal();
      }
    });
  }

  showDoorModal(door, doorNumber) {
    const doorBack = door.querySelector('.door-back');
    const title = doorBack.querySelector('.door-content-title')?.textContent || `Türchen ${doorNumber}`;
    const offer = doorBack.querySelector('.door-content-offer')?.textContent || '';
    const image = doorBack.querySelector('.door-content-image')?.src || '';
    const link = doorBack.querySelector('.door-content-btn')?.href || '#';
    const buttonText = doorBack.querySelector('.door-content-btn')?.textContent || '';
    const isContestDoor = door?.dataset?.contestDoor === 'true';

    const modal = document.getElementById('advent-modal');
    if (!modal) return;

    modal.querySelector('.modal-title').textContent = title;
    modal.querySelector('.modal-description').innerHTML = offer;
    
    const modalImage = modal.querySelector('.modal-image');
    if (image) {
      modalImage.src = image;
      modalImage.style.display = 'block';
    } else {
      modalImage.style.display = 'none';
    }
    
    const originalModalCta = modal.querySelector('.modal-cta');
    let modalCta = originalModalCta;

    if (originalModalCta) {
      modalCta = originalModalCta.cloneNode(true);
      originalModalCta.parentNode.replaceChild(modalCta, originalModalCta);
    }

    if (modalCta) {
      if (isContestDoor) {
        modalCta.href = '#';
        modalCta.textContent = buttonText || door.dataset.contestButton || 'Am Gewinnspiel teilnehmen';
        modalCta.dataset.contestDoor = 'true';
        modalCta.dataset.contestTitle = door.dataset.contestTitle || title;
        modalCta.dataset.contestDescription = door.dataset.contestDescription || offer;
        modalCta.dataset.contestQuestion = door.dataset.contestQuestion || '';
        modalCta.dataset.contestButton = door.dataset.contestButton || modalCta.textContent;
        modalCta.dataset.contestDay = door.dataset.contestDay || doorNumber;
        modalCta.dataset.contestDayLabel = door.dataset.contestDayLabel || `Türchen ${doorNumber}`;
        modalCta.addEventListener('click', (event) => {
          event.preventDefault();
          this.closeModal();
          document.dispatchEvent(new CustomEvent('advent:contest-open', {
            detail: {
              title: modalCta.dataset.contestTitle,
              description: modalCta.dataset.contestDescription,
              question: modalCta.dataset.contestQuestion,
              button: modalCta.dataset.contestButton,
              day: modalCta.dataset.contestDay,
              dayLabel: modalCta.dataset.contestDayLabel
            }
          }));
        });
      } else {
        modalCta.href = link;
        modalCta.textContent = buttonText || 'Jetzt sichern!';
        modalCta.removeAttribute('data-contest-door');
        modalCta.removeAttribute('data-contest-title');
        modalCta.removeAttribute('data-contest-description');
        modalCta.removeAttribute('data-contest-question');
        modalCta.removeAttribute('data-contest-button');
        modalCta.removeAttribute('data-contest-day');
        modalCta.removeAttribute('data-contest-day-label');
      }
    }
    
    // Rabattcode erkennen und Kopier-Button hinzufügen
    const couponCode = this.extractCouponCode(buttonText);
    const couponContainer = modal.querySelector('.modal-coupon-code');
    
    if (couponCode && couponContainer) {
      couponContainer.style.display = 'flex';
      couponContainer.querySelector('.coupon-code-text').textContent = couponCode;
      
      // Event Listener für Kopier-Button (mit Event-Propagation Stop)
      const copyBtn = couponContainer.querySelector('.copy-code-btn');
      
      // Alte Event Listener entfernen
      const newCopyBtn = copyBtn.cloneNode(true);
      copyBtn.parentNode.replaceChild(newCopyBtn, copyBtn);
      
      // Neuer Event Listener mit preventDefault
      newCopyBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.copyCouponCode(couponCode, newCopyBtn);
      });
      
      // Auch für die Code-Box selbst (macht sie klickbar zum Kopieren)
      const codeBox = couponContainer.querySelector('.coupon-code-box');
      const newCodeBox = codeBox.cloneNode(true);
      codeBox.parentNode.replaceChild(newCodeBox, codeBox);
      
      newCodeBox.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.copyCouponCode(couponCode, newCopyBtn);
      });
      newCodeBox.style.cursor = 'pointer';
      newCodeBox.title = 'Klicken zum Kopieren';
      
      // CTA Button Text anpassen
      if (!isContestDoor && modalCta) {
        modalCta.textContent = 'Zum Angebot';
      }
    } else {
      couponContainer.style.display = 'none';
      if (!isContestDoor && modalCta) {
        modalCta.textContent = buttonText || 'Jetzt sichern!';
      }
    }

    modal.classList.add('active');
    document.body.style.overflow = 'hidden';
    
    this.playSound('modal-open');
    
    // Confetti Effect
    this.createConfetti();
  }

  /**
   * RABATTCODE EXTRAKTION
   * Erkennt Codes in verschiedenen Formaten:
   * - "Code: ADVENT10"
   * - "ADVENT10"
   * - "Gutschein: WEIHNACHT20"
   */
  extractCouponCode(text) {
    if (!text) return null;
    
    // Muster 1: "Code: XXXXX" oder "Gutschein: XXXXX"
    const pattern1 = /(?:code|gutschein|rabatt):\s*([A-Z0-9-_]+)/i;
    const match1 = text.match(pattern1);
    if (match1) return match1[1].toUpperCase();
    
    // Muster 2: Nur Großbuchstaben und Zahlen (min. 4 Zeichen)
    const pattern2 = /\b([A-Z0-9]{4,15})\b/;
    const match2 = text.match(pattern2);
    if (match2) return match2[1];
    
    return null;
  }

  /**
   * RABATTCODE KOPIEREN
   */
  copyCouponCode(code, button) {
    // In Zwischenablage kopieren
    navigator.clipboard.writeText(code).then(() => {
      // Visuelles Feedback
      const originalIcon = button.innerHTML;
      button.innerHTML = '✓';
      button.style.background = '#28a745';
      
      // Temporäre Erfolgsmeldung
      const feedback = document.createElement('div');
      feedback.className = 'copy-feedback';
      feedback.textContent = '✓ Code kopiert!';
      feedback.style.cssText = `
        position: absolute;
        top: -40px;
        left: 50%;
        transform: translateX(-50%);
        background: #28a745;
        color: white;
        padding: 8px 16px;
        border-radius: 20px;
        font-size: 0.9rem;
        font-weight: 700;
        white-space: nowrap;
        animation: fadeInOut 2s ease;
        z-index: 10;
      `;
      
      button.parentElement.style.position = 'relative';
      button.parentElement.appendChild(feedback);
      
      // Nach 2 Sekunden zurücksetzen
      setTimeout(() => {
        button.innerHTML = originalIcon;
        button.style.background = '';
        feedback.remove();
      }, 2000);
      
      debugLog(`📋 Code kopiert: ${code}`);
    }).catch(err => {
      debugError('Kopieren fehlgeschlagen', err);
      
      // Fallback: Text-Selektion
      const tempInput = document.createElement('input');
      tempInput.value = code;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand('copy');
      document.body.removeChild(tempInput);
      
      button.innerHTML = '✓';
      setTimeout(() => {
        button.innerHTML = '📋';
      }, 2000);
    });
  }

  closeModal() {
    const modal = document.getElementById('advent-modal');
    if (!modal) return;

    modal.classList.remove('active');
    document.body.style.overflow = '';
  }

  /**
   * PROGRESS BAR
   */
  initProgressBar() {
    this.updateProgressBar();
  }

  updateProgressBar() {
    const progressFill = document.querySelector('.progress-bar-fill');
    const progressText = document.querySelector('.progress-text');
    
    if (!progressFill || !progressText) return;

    const totalDoors = 24;
    const openedCount = this.openedDoors.length;
    const percentage = (openedCount / totalDoors) * 100;

    progressFill.style.width = `${percentage}%`;
    progressFill.textContent = `${Math.round(percentage)}%`;
    
    // Übersetzung aus Config holen und Platzhalter ersetzen
    const progressTemplate = this.config.translations?.progressTemplate || '{{ opened }} von {{ total }} Türchen geöffnet';
    const progressText_translated = progressTemplate
      .replace(/\{\{\s*opened\s*\}\}/g, openedCount)
      .replace(/\{\{\s*total\s*\}\}/g, totalDoors);
    
    progressText.textContent = progressText_translated;
  }

  /**
   * CONFETTI EFFEKT
   */
  createConfetti() {
    const colors = ['#C41E3A', '#D4AF37', '#165B33', '#FFFFFF'];
    const confettiCount = 50;

    for (let i = 0; i < confettiCount; i++) {
      const confetti = document.createElement('div');
      confetti.style.cssText = `
        position: fixed;
        width: ${5 + Math.random() * 10}px;
        height: ${5 + Math.random() * 10}px;
        background: ${colors[Math.floor(Math.random() * colors.length)]};
        top: -10px;
        left: ${Math.random() * 100}%%;
        opacity: ${0.5 + Math.random() * 0.5};
        transform: rotate(${Math.random() * 360}deg);
        z-index: 10001;
        pointer-events: none;
        border-radius: ${Math.random() > 0.5 ? '50%' : '0'};
        animation: confettiFall ${2 + Math.random() * 3}s ease-out forwards;
      `;

      document.body.appendChild(confetti);

      setTimeout(() => {
        confetti.remove();
      }, 5000);
    }
  }

  /**
   * SOUND EFFECTS
   */
  playSound(soundType) {
    if (!this.config.soundEnabled) return;

    const sounds = {
      'door-open': 'https://cdn.shopify.com/s/files/1/0000/0000/files/bell.mp3',
      'locked': 'https://cdn.shopify.com/s/files/1/0000/0000/files/lock.mp3',
      'modal-open': 'https://cdn.shopify.com/s/files/1/0000/0000/files/success.mp3'
    };

    const audio = new Audio(sounds[soundType]);
    audio.volume = 0.3;
    audio.play().catch(() => {
      // Sound failed - continue silently
    });
  }

  /**
   * BACKGROUND AUDIO
   */
  initBackgroundAudio() {
    if (!this.config.audioUrl) return;

    const audio = new Audio(this.config.audioUrl);
    audio.loop = true;
    audio.volume = (this.config.audioVolume || 20) / 100;

    const toggleBtn = document.getElementById('audio-toggle');
    if (!toggleBtn) return;

    let isPlaying = false;

    toggleBtn.addEventListener('click', () => {
      if (isPlaying) {
        audio.pause();
        toggleBtn.textContent = '🔇';
        toggleBtn.setAttribute('aria-label', 'Musik einschalten');
      } else {
        audio.play().catch(() => {
          debugLog('Audio playback requires user interaction');
        });
        toggleBtn.textContent = '🔊';
        toggleBtn.setAttribute('aria-label', 'Musik ausschalten');
      }
      isPlaying = !isPlaying;
    });
  }

  /**
   * LOCAL STORAGE
   */
  loadOpenedDoors() {
    try {
      // Im Test-Modus mit "reset" Parameter: Local Storage leeren
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('reset') === 'true') {
        localStorage.removeItem('adventCalendarOpened');
        debugLog('🗑️ Local Storage zurückgesetzt');
        return [];
      }
      
      const stored = localStorage.getItem('adventCalendarOpened');
      return stored ? JSON.parse(stored) : [];
    } catch (e) {
      return [];
    }
  }

  saveOpenedDoors() {
    try {
      localStorage.setItem('adventCalendarOpened', JSON.stringify(this.openedDoors));
    } catch (e) {
      debugError('Could not save to localStorage', e);
    }
  }

  /**
   * HELPER FUNCTIONS
   */
  isMobile() {
    return window.innerWidth <= 768;
  }
}

/**
 * CSS ANIMATIONS (dynamisch hinzugefügt)
 */
if (!document.getElementById('advent-calendar-animations')) {
  const adventAnimationStyle = document.createElement('style');
  adventAnimationStyle.id = 'advent-calendar-animations';
  adventAnimationStyle.textContent = `
    @keyframes shake {
      0%, 100% { transform: translateX(0); }
      25% { transform: translateX(-10px) rotate(-5deg); }
      75% { transform: translateX(10px) rotate(5deg); }
    }
    
    @keyframes fadeInOut {
      0%, 100% { opacity: 0; transform: translate(-50%, -50%) scale(0.8); }
      10%, 90% { opacity: 1; transform: translate(-50%, -50%) scale(1); }
    }
    
    @keyframes confettiFall {
      to {
        transform: translateY(100vh) rotate(720deg);
        opacity: 0;
      }
    }
  `;
  document.head.appendChild(adventAnimationStyle);
}

/**
 * INITIALISIERUNG
 */
function initAdventCalendar() {
  const calendarElement = document.querySelector('.advent-calendar-landing');
  
  if (!calendarElement) {
    debugWarn('⚠️ Adventskalender-Element nicht gefunden. Warte...');
    return;
  }
  
  // Verhindere doppelte Initialisierung
  if (calendarElement.dataset.initialized === 'true') {
    debugLog('⚠️ Adventskalender bereits initialisiert, überspringe...');
    return;
  }
  
  debugLog('🎅 Starte Adventskalender...');
  calendarElement.dataset.initialized = 'true';
  new AdventCalendar();
}

// Mehrere Initialisierungspunkte für maximale Kompatibilität
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAdventCalendar);
} else {
  // DOM ist bereits geladen
  initAdventCalendar();
}

// Shopify Theme-Editor Support
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', initAdventCalendar);
}

